import Tooltip from "@mui/material/Tooltip";
import {
  getCompletionPercent,
  getCompletionTone,
  getMissingAnalysisFields,
} from "./cropYearCompletion.js";

export default function CropYearCompletionIndicator({
  cropYear = {},
  compact = false,
}) {
  const completionPercent = getCompletionPercent(cropYear);
  const tone = getCompletionTone(cropYear);
  const missingFields = getMissingAnalysisFields(cropYear);

  const content = (
    <div className={`flex flex-col ${compact ? "gap-1" : "gap-2"}`}>
      <div className="flex items-center justify-between gap-3">
        <span className={`text-xs font-semibold ${tone.textClassName}`}>
          {tone.label}
        </span>
        <span className="text-xs font-bold text-slate-600">
          {completionPercent}%
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200">
        <div
          className={`h-full rounded-full transition-all ${tone.barClassName}`}
          style={{ width: `${completionPercent}%` }}
        />
      </div>
      {!compact && missingFields.length > 0 && (
        <p className="text-xs leading-5 text-slate-500">
          Still needed: {missingFields.join(", ")}
        </p>
      )}
    </div>
  );

  if (compact && missingFields.length > 0) {
    return (
      <Tooltip title={`Still needed: ${missingFields.join(", ")}`}>
        <div>{content}</div>
      </Tooltip>
    );
  }

  return content;
}
